import { render, staticRenderFns } from "./CatalogHistory.vue?vue&type=template&id=d413a760"
import script from "./CatalogHistory.vue?vue&type=script&lang=js"
export * from "./CatalogHistory.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports